module.exports = __webpack_public_path__ + "static_wap/img/avatar.38c09fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/avatar.png
// module id = YmJB
// module chunks = 1